import AnalyticsRepository from './AnalyticsRepository';

export const analytics = new AnalyticsRepository();

export { AB_TEST_VARIATIONS } from './contants';
